/*********************
* Intervention Factory *
*
* instantiates and returns interventions of specified type
*********************/
// Interventions
import Intervention from './Intervention';
// Constants
import { interventionTypes, interventionRequiredFields } from '../constants';

export default function getIntervention(interventionType, ruleData={}, interventionMode=null) {
  let intervention = null;
  let requiredFields = interventionRequiredFields[interventionType];
  if(requiredFields) { // deep copy fields, if they exist
    requiredFields = JSON.parse(JSON.stringify(requiredFields));
  }
  let i = interventionTypes;
  switch(interventionType) {
    case i.clap:
    case i.lipsync:
    case i.sayit:
    case i.spellout:
    case i.spelloutBefore:
    case i.read:
    case i.none:
    case i.toofast:
    case i.repeatsentence:
    case i.repeatsentenceErrorsEmphasized:
    case i.simpledefinition:
    case i.skip:
    case i.tense:
    case i.funfact:
    case i.readwithme:
    case i.initiateReadWithMe:
    case i.sight:
    case i.giveword:
    case i.phonemeGiveWord:
    case i.phonemeLipsync:
    case i.videoLipsync:
    case i.comprehension:
    case i.cognate:
    case i.prediction:
    case i.vocabularyWithPictures:
    case i.morpheme:
    case i.name1:
    case i.name2:
    case i.riddle:
    case i.letterFlies:
    case i.sayASound:
    case i.soundSeeker:
    case i.soundout1:
    case i.soundout2:
    case i.soundout3:
    case i.elkoninBox0:
    case i.elkoninBox1:
    case i.elkoninBox2:
    case i.elkoninBox3:
    case i.elkoninBox4:
    case i.upAndDown1:
    case i.upAndDown2:
    case i.upAndDown3:
    case i.wordDisplay:
    case i.changeOnePart1:
    case i.giveAndTake1:
    case i.rhyming1:
    case i.rhymingQuiz1:
    case i.sayOneSound1:
    case i.wordInvestigator1:
    case i.wordInvestigator2:
    case i.wordScramble1:
      intervention = new Intervention(
        interventionType,
        requiredFields,
        ruleData,
        interventionMode,
      );
    break;
    default:
      console.log('ERROR: invalid intervention type as a param of interventionFactory: ', interventionType);
    break;
  }
  return intervention;
}